import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class ApprovalManagerService {
    constructor(options) {
        this._options = options;
        this._restClient = new RestClient();
        this._rc = new RealtimeClient();
    }

    /**
     * Create a change request
     * @param {object} device
     * @param {function} callback
     */
    create(changeType, request, callback) {
        const url = "/approval-manager-app/api/changeRequests";
        const body = JSON.stringify({
            changeType,
            request
        });
        this._restClient.exec_post(url, body, callback);
    }

    getByAppId(appId, callback) {
        const url = `/approval-manager-app/api/changeRequests/${appId}`;

        this._restClient.exec_get(url, callback);
    }

    approve(requestId, callback) {
        const url = `/approval-manager-app/api/changeRequests/approve/${requestId}`;

        this._restClient.exec_put(url, null, callback);
    }

    deny(requestId, callback) {
        const url = `/approval-manager-app/api/changeRequests/deny/${requestId}`;

        this._restClient.exec_put(url, null, callback);
    }

    cancel(requestId, callback) {
        const url = `/approval-manager-app/api/changeRequests/cancel/${requestId}`;

        this._restClient.exec_put(url, null, callback);
    }

    streamChangeRequests(appId, callback) {
        const args = {
            appId: appId
        };
        return this._rc.subscribe("approval-manager-app", "/changeRequests", args, function (msg) {
            const response = JSON.parse(msg);
            if (response) {
                if (callback) {
                    callback(null, response);
                }
            }
        });
    }

}
